import { dataArrowRightSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowRightSolid = /*#__PURE__*/createIcon(dataArrowRightSolid)
export default IconArrowRightSolid
